import React from "react";
import { Link } from "react-router-dom";
import { formatTL } from "@/lib/api";

export default function ProductCard({ product, currency = "₺" }) {
  const onSale = product.sale_price && product.sale_price < product.price;
  return (
    <Link to={`/urun/${product.slug}`} className="group block" data-testid={`product-card-${product.slug}`}>
      <div className="relative aspect-[4/5] overflow-hidden rounded-xl bg-larc-alt">
        {product.images?.[0] ? (
          <img src={product.images[0]} alt={product.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-larc-muted text-sm">Görsel yok</div>
        )}
        {onSale && (
          <span className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-larc-ink text-[10px] px-3 py-1 rounded-full uppercase tracking-[0.15em] shadow-sm">İndirim</span>
        )}
        {product.featured && !onSale && (
          <span className="absolute top-4 left-4 bg-larc-ink/90 text-white text-[10px] px-3 py-1 rounded-full uppercase tracking-[0.15em]">Öne Çıkan</span>
        )}
        {product.stock <= 0 && (
          <span className="absolute top-4 right-4 bg-white text-larc-ink text-[10px] px-3 py-1 rounded-full uppercase tracking-[0.15em] shadow-sm">Tükendi</span>
        )}
      </div>
      <div className="mt-5 text-center">
        <h3 className="font-heading text-xl text-larc-ink">{product.name}</h3>
        <p className="text-xs uppercase tracking-[0.18em] text-larc-gold mt-1">{product.category_slug?.replace("-", " ")}</p>
        <div className="mt-2 flex items-center justify-center gap-2 text-sm">
          {onSale ? (
            <>
              <span className="text-larc-muted line-through">{formatTL(product.price, currency)}</span>
              <span className="text-larc-ink font-medium">{formatTL(product.sale_price, currency)}</span>
            </>
          ) : (
            <span className="text-larc-ink font-medium">{formatTL(product.price, currency)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
